import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-community',
  templateUrl: './community.component.html',
  styleUrls: ['./community.component.scss'],
})
export class CommunityComponent {
  @Input() src: any = '';
  @Input() title: string = '';
  @Input() text: string = '';
  @Input() url: string = '';
}
